import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';

export const HEADER_IMAGES_PROPTYPES = {
    mobile: PropTypes.string,
    tablet: PropTypes.string,
    desktop: PropTypes.string,
    twok: PropTypes.string,
};

export const HEADER_PROPTYPES = {
    images: PropTypes.shape(HEADER_IMAGES_PROPTYPES),
    attribution: PropTypes.oneOfType([PropTypes.string, translationPropType]),
    shouldShowCustomHeader: PropTypes.bool,
    customContentCtaLabel: PropTypes.string,
    customContentCtaLink: PropTypes.string,
    customContentCtaPrefix: PropTypes.string,
    customLinkLabel: translationPropType,
};
